import React from "react";

/**
 * @deprecated Use Grid
 * @param props
 */
export default (props: {}) => <i className="fas fa-fw" {...props} />;
